import React, { Component } from 'react';
import { Divider, Tag, Row, Col, Descriptions, Table, Typography } from 'antd'
import ReactHtmlParser from 'react-html-parser';
import { isValidDate } from '@/utils/helpers';
import PhoneNumberList from '@/components/PhoneNumberList';

const { Paragraph } = Typography;

class FamilyRelationshipsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showOldData: false
        };
    }

    render() {

        var { currentItem } = this.props;

        var family_columns = [
            {
                title: "Họ và tên",
                dataIndex: "full_name",
                render: (text, record) => {
                    return (
                        <>{record?.related_customer?.full_name}</>
                    )
                }
            },
            {
                title: "Mã",
                dataIndex: "code",
                width: "140px",
                render: (text, record) => {
                    return (
                        <>
                            <Paragraph style={{ margin: 0 }} copyable={
                                {
                                    text: record?.related_customer?.code,
                                    tooltips: false
                                }
                            }>
                                <Tag color='#1890ff'>{record?.related_customer?.code}</Tag>
                            </Paragraph>
                        </>
                    )
                }
            },
            {
                title: "Số điện thoại",
                dataIndex: "phone",
                width: "120px",
                render: (text, record) => {
                    return (
                        <PhoneNumberList phones={record.phones} relatedPhones={record.family_relationships} />
                    )
                }
            },
            {
                title: "Năm sinh",
                dataIndex: "birthday",
                width: "120px",
                render: (text, record) => {
                    return (
                        <>{isValidDate(record?.related_customer?.birthday, false)}</>
                    )
                }
            },
            {
                title: "Quan hệ",
                dataIndex: "relationship",
                width: "120px",
                render: (text, record) => {
                    return (
                        <>{record?.relationship_types?.name}</>
                    )
                }
            }
        ];

        return (
            <>
                {/* <Divider orientation="left" orientationMargin="0" className='mt-3'>
                    <Tag color='#0b2b33'>10</Tag> Thông tin nhân khẩu
                </Divider> */}
                <Row gutter={16}>
                    <Col xs={24} md={24}>
                        <Descriptions size="small">
                            <Descriptions.Item label="Tỉnh/Thành phố">
                                {currentItem ? currentItem.province_name : null}
                            </Descriptions.Item>
                        </Descriptions>
                        <Divider className="no-margin" />
                    </Col>
                    <Col xs={24} md={24}>
                        <Descriptions size="small">
                            <Descriptions.Item label="Quận/Huyện">
                                {currentItem ? currentItem.district_name : null}
                            </Descriptions.Item>
                        </Descriptions>
                        <Divider className="no-margin" />
                    </Col>
                    <Col xs={24} md={24}>
                        <Descriptions size="small">
                            <Descriptions.Item label="Phường/Xã">
                                {currentItem ? currentItem.wards_name : null}
                            </Descriptions.Item>
                        </Descriptions>
                        <Divider className="no-margin" />
                    </Col>
                    <Col xs={24} md={24}>
                        <Descriptions size="small">
                            <Descriptions.Item label="Địa chỉ">
                                {currentItem ? ReactHtmlParser(currentItem.address) : null}
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col xs={24} md={24}>
                        <Table
                            bordered
                            title={() => <>
                                <strong>Thành viên trong gia đình</strong>
                            </>}
                            size='small'
                            rowKey='key'
                            tableLayout="auto"
                            columns={family_columns}
                            locale={{ emptyText: "Chưa có dữ liệu" }}
                            dataSource={currentItem ? currentItem.family_relationships : []}
                            pagination={false}
                            scroll={{
                                x: 'max-content'
                            }}
                        />
                    </Col>
                </Row>
            </>
        )
    }
}

export default (FamilyRelationshipsList);
